{
  "name": "fourcomply-dashboard",
  "version": "3.0.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start:dashboard": "ng dev fourcomply-dashboard",
    "start:forms": "ng dev forms-app",
    "build-dev-dashboard": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build fourcomply-dashboard --configuration=dev",
    "build-dev-forms": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build forms-app --configuration=dev",
    "build-staging-dashboard": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build fourcomply-dashboard --configuration=staging && npm run obfuscate-dashboard",
    "build-staging-forms": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build forms-app --configuration=staging && npm run obfuscate-forms",
    "build-demo-dashboard": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build fourcomply-dashboard --configuration=demo --output-path=distdemo/apps/fourcomply-dashboard && npm run obfuscate-dashboard",
    "build-demo-forms": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build forms-app --configuration=demo --output-path=distdemo/apps/forms-app && npm run obfuscate-forms",
    "build-prod-dashboard": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build fourcomply-dashboard --configuration=production && npm run obfuscate-dashboard",
    "build-prod-forms": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build forms-app --configuration=production && npm run obfuscate-forms",
    "build-eu-dashboard": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build fourcomply-dashboard --configuration=eu --output-path=disteu/apps/fourcomply-dashboard && npm run obfuscate-dashboard",
    "build-eu-forms": "node --max_old_space_size=12000 ./node_modules/@angular/cli/bin/ng build forms-app --configuration=eu --output-path=disteu/apps/forms-app && npm run obfuscate-forms",
    "obfuscate-dashboard": "ng run fourcomply-dashboard:obfuscate:production",
    "obfuscate-forms": "ng run forms-app:obfuscate:production",
    "clean": "rimraf .cache && rimraf dist && rimraf node_modules",
    "e2e": "ng e2e",
    "lint": "ng lint --cache",
    "refresh-project": "npm run clean && npm install --legacy-peer-deps --force",
    "test": "ng test",
    "affected:apps": "nx affected:apps",
    "affected:libs": "nx affected:libs",
    "affected:build": "nx affected:build",
    "affected:e2e": "nx affected:e2e",
    "affected:test": "nx affected:test",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "affected": "nx affected",
    "format": "nx format:write",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "update": "nx migrate latest",
    "update:check": "ng update",
    "workspace-schematic": "nx workspace-schematic",
    "dep-graph": "nx dep-graph",
    "help": "nx help"
  },
  "private": true,
  "dependencies": {
    "@amcharts/amcharts4": "4.10.39",
    "@amcharts/amcharts4-geodata": "4.1.30",
    "@angular/animations": "18.2.7",
    "@angular/cdk": "18.2.6",
    "@angular/common": "18.2.7",
    "@angular/compiler": "18.2.7",
    "@angular/core": "18.2.7",
    "@angular/forms": "18.2.7",
    "@angular/localize": "18.2.7",
    "@angular/material": "18.2.6",
    "@angular/platform-browser": "18.2.7",
    "@angular/platform-browser-dynamic": "18.2.7",
    "@angular/router": "18.2.7",
    "@auth0/auth0-spa-js": "2.1.3",
    "@ckeditor/ckeditor5-angular": "9.0.0",
    "@ng-select/ng-select": "13.9.1",
    "@ngx-formly/bootstrap": "6.3.7",
    "@ngx-formly/core": "6.3.7",
    "@ngx-formly/material": "6.3.7",
    "@ngx-translate/core": "15.0.0",
    "@ngx-translate/http-loader": "8.0.0",
    "@nrwl/angular": "11.0.0",
    "@russcarver/ngx-source-obfuscation": "18.0.0",
    "@swimlane/ngx-datatable": "20.1.0",
    "@syncfusion/ej2-angular-kanban": "27.1.51",
    "auth0-js": "9.27.0",
    "chart.js": "4.4.4",
    "ckeditor5": "43.2.0",
    "core-js": "3.38.1",
    "dragula": "3.7.3",
    "gridstack": "12.2.2",
    "gridstack-angular": "0.6.0-dev",
    "jqwidgets-ng": "20.0.0",
    "jwt-decode": "4.0.0",
    "muuri": "0.9.5",
    "ng2-charts": "6.0.1",
    "ng2-dragula": "5.1.0",
    "ngx-clipboard": "16.0.0",
    "ngx-toastr": "19.0.0",
    "ngx-uploader": "17.0.1",
    "ngx-webstorage-service": "5.0.0",
    "npm": "10.8.3",
    "qrcode": "1.5.4",
    "rxjs": "7.8.1",
    "sass": "1.79.4",
    "sortablejs": "1.15.6",
    "spectre.scss": "0.0.3",
    "tslib": "2.7.0",
    "xng-breadcrumb": "12.0.0",
    "zone.js": "0.14.10"
  },
  "overrides": {
    "ng2-dragula": {
      "@angular/animations": "$@angular/animations",
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    }
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "18.2.7",
    "@angular-eslint/builder": "18.3.1",
    "@angular-eslint/eslint-plugin": "18.3.1",
    "@angular-eslint/eslint-plugin-template": "18.3.1",
    "@angular-eslint/schematics": "18.3.1",
    "@angular-eslint/template-parser": "18.3.1",
    "@angular/cli": "18.2.7",
    "@angular/compiler-cli": "18.2.7",
    "@angular/language-service": "18.2.7",
    "@nrwl/cli": "11.0.0",
    "@nrwl/cypress": "11.0.0",
    "@nrwl/jest": "11.0.0",
    "@nrwl/tao": "11.0.0",
    "@nrwl/workspace": "11.0.0",
    "@types/d3-geo": "3.1.0",
    "@types/dragula": "3.7.5",
    "@types/jest": "29.5.13",
    "@types/node": "22.7.4",
    "@types/qrcode": "1.5.6",
    "@types/sortablejs": "1.15.8",
    "@typescript-eslint/eslint-plugin": "8.8.0",
    "@typescript-eslint/parser": "8.8.0",
    "cypress": "13.15.0",
    "dotenv": "16.4.5",
    "eslint": "8.57.1",
    "eslint-plugin-import": "2.30.0",
    "eslint-plugin-jsdoc": "50.3.1",
    "eslint-plugin-no-null": "1.0.2",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "eslint-plugin-unicorn": "55.0.0",
    "jest": "29.7.0",
    "jest-preset-angular": "14.2.4",
    "prettier": "3.3.3",
    "rimraf": "6.0.1",
    "ts-jest": "29.2.5",
    "ts-node": "10.9.2",
    "typescript": "5.5.4"
  },
  "engineStrict": true,
  "engines": {
    "node": "22.9.0",
    "npm": "10.8.3"
  }
}
